import Backbone from 'backbone'
import ObjectSelectorMenu from 'scoreboard/components/bootslide/object-selector-menu'
import objectSelectorMenu from 'scoreboard/components/bootslide/object-selector-menu'
import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'


const WIDGET_TYPES_WITHOUT_DEFAULT_DRILLDOWNS = [
	'text', 'image', 'initiative-timeline', 'initiative-chart', 'notes',
	'dataset-table', 'dataset-filter', 'chart', 'chart-table', 'report',
	'embedded-content'
]

var WobDrilldownMenu = ObjectSelectorMenu.Option.extend({
	selectorOptions: function (opt) {
		// #31906 if drilldownSection property is set to 'none', these can all be null
		let { section, id, orgId, projectId } = this.model.drilldown() || {}
		let selectorOptions

		let drillSection = this.model.properties.get('drilldownSection')
		if (drillSection != 'default' && drillSection != 'none') {
			section = drillSection
		}
		// If we're opening up a drilldown menu which is the same section as the
		// current drilldown object, make sure we go to the org and project of the
		// item already selected.
		if (this.section == section) {
			selectorOptions = {
				section,
				id,
				orgId,
				projectId
			}
		// If we're opening up a drilldown menu which is NOT the same section as
		// the current drilldown object, open to the default org/project
		} else {
			selectorOptions = {
				section: this.section
			}
		}

		if (this.section === 'datasets') {
			selectorOptions.datasetsOnly = false
		}

		// Show the project selector so we can drill down to objects in other projects
		selectorOptions.showProjectSelector = true

		return selectorOptions
	},

	buttonLabelCode: 'common.select',

	select: function () {
		let { projectId, organizationId, id } = this.objectSelector.getSelectedState()

		this.model.drilldown({
			section: this.section,
			id,
			projectId,
			organizationId
		})

		this.trigger('back')
	}
})

WobDrilldownMenu.buildMenu = function (configView, canvas) {
	var drilldown
	if (canvas.selection.wobs.length === 1) {
		drilldown = objectSelectorMenu(configView, 'dashboards.drilldown', WobDrilldownMenu, DrilldownSectionLabel)
	} else {
		// if multiple wobs selected on the canvas, only show "default" and "none" drilldown options
		drilldown = { label: i18n.get('dashboards.drilldown'), target: []}
	}

	const widgetTypes = _(canvas.selection.wobs)
		.map(it => it.widget.get('type'))
		.uniq()
		.value()

	const defaultlessTypesSelected = _.difference(
		widgetTypes, WIDGET_TYPES_WITHOUT_DEFAULT_DRILLDOWNS
	).length !== widgetTypes.length

	if (!defaultlessTypesSelected) {
		drilldown.target.unshift({
				label: 'default',
				contentView: ToggleDefaultDrilldown
		})
	}

	drilldown.target.unshift({
		label: 'none',
		contentView: ToggleNoDrilldown
	})

	drilldown.type = 'submenu'

	return drilldown
}

var ToggleDrilldown = Backbone.View.extend({
	className: 'config-checkmark',

	events: {
		'click': 'toggle'
	},

	initialize: function (options) {
		this.options = options
		this.listenTo(this.model, 'change:properties', this.render.bind(this))
	},

	render: function () {
		this.$el.html(i18n.get(this.label))
			.toggleClass('is-selected', this.val())
			.append(icon('approved', 'check-icon'))

		return this
	},

	val: function () {
		return this.effectiveSectionValue() === this.sectionValue
	},

	toggle: function () {
		this.options.widgetUpdater.applyUpdate(widget => {
			widget.drilldown({
				section: this.sectionValue,
				id: null
			})
		})

		this.render()
	},

	effectiveSectionValue: function() {
		const drilldownSection = this.model.properties.get('drilldownSection')

		if (drilldownSection) {
			return drilldownSection
		} else {
			const typeHasDefaultDrilldown =
				WIDGET_TYPES_WITHOUT_DEFAULT_DRILLDOWNS.indexOf(
					this.model.properties.get('type')
				) < 0
			return typeHasDefaultDrilldown ? 'default' : 'none'
		}
	}
})

var ToggleDefaultDrilldown = ToggleDrilldown.extend({
	label: 'common.default',
	sectionValue: 'default'
})

var ToggleNoDrilldown = ToggleDrilldown.extend({
	label: 'common.none',
	sectionValue: 'none'
})

var DrilldownSectionLabel = ObjectSelectorMenu.SectionLabel.extend({
	className: 'config-checkmark drilldown-section',
	initialize: function () {
		this.listenTo(this.model, 'change:properties', this.render.bind(this))
	},
	render: function () {
		ObjectSelectorMenu.SectionLabel.prototype.render.apply(this, arguments)

		this.$el.toggleClass('is-selected', this.model.properties.get('drilldownSection') === this.section)
			.prepend(icon('approved', 'check-icon'))

		return this
	}
})

export default WobDrilldownMenu

WobDrilldownMenu.__filename__ = 'dashboards/widgets/wob-drilldown-menu.js'
